import React from 'react';

// PWA Components - All disabled to prevent update dialog issues

// Empty provider - just passes through children
export const PWAProvider = ({ children }) => {
  return <>{children}</>;
};

// Disabled components - return null
export const OfflineIndicator = () => null;
export const SyncStatus = () => null;
export const UpdateBanner = () => null;
export const PWAInstallBanner = () => null;
export const NotificationPermission = () => null;
export const PWAInstallGuide = () => null;

// Empty context for any components that might try to use it
export const usePWA = () => ({
  isOnline: true,
  isInstalled: false,
  canInstall: false,
  installApp: () => {},
});

export default PWAProvider;
